/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import type { FC, SVGAttributes } from "react";

type Props = SVGAttributes<SVGElement>;

// FcWithoutChildren にしたいが props の定義が react に沿いきってないみたいでエラーが出るため FC を利用
export const PlusIcon: FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M11.8337 6.83317H6.83366V11.8332H5.16699V6.83317H0.166992V5.1665H5.16699V0.166504H6.83366V5.1665H11.8337V6.83317Z"
        fill="currentColor"
      />
    </svg>
  );
};
